import '../assets/ComboboxChevron.css';var _ = Object.defineProperty, g = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, v = Object.prototype.propertyIsEnumerable;
var l = (o, e, r) => e in o ? _(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, c = (o, e) => {
  for (var r in e || (e = {}))
    m.call(e, r) && l(o, r, e[r]);
  if (n)
    for (var r of n(e))
      v.call(e, r) && l(o, r, e[r]);
  return o;
}, a = (o, e) => g(o, z(e));
var h = (o, e) => {
  var r = {};
  for (var s in o)
    m.call(o, s) && e.indexOf(s) < 0 && (r[s] = o[s]);
  if (o != null && n)
    for (var s of n(o))
      e.indexOf(s) < 0 && v.call(o, s) && (r[s] = o[s]);
  return r;
};
import { jsx as b } from "react/jsx-runtime";
import { j as R, b as S, B } from "../factory-BnRIVbT0.js";
import { u as j, c as N } from "../use-styles-BXCSW-9F.js";
import { c as P } from "../get-size-BzhHC8s2.js";
const M = "ComboboxChevron-module__chevron___w-2dT", T = {
  chevron: M
}, V = {
  error: null
}, Z = N((o, { size: e }) => ({
  chevron: {
    "--combobox-chevron-size": P(e, "combobox-chevron-size")
  }
})), F = R((o, e) => {
  const r = S("ComboboxChevron", V, o), t = r, { size: s, error: i, style: C, className: p, classNames: d, styles: x, unstyled: u, vars: f, mod: w } = t, y = h(t, ["size", "error", "style", "className", "classNames", "styles", "unstyled", "vars", "mod"]), L = j({
    name: "ComboboxChevron",
    classes: T,
    props: r,
    style: C,
    className: p,
    classNames: d,
    styles: x,
    unstyled: u,
    vars: f,
    varsResolver: Z,
    rootSelector: "chevron"
  });
  return /* @__PURE__ */ b(
    B,
    a(c(c({
      component: "svg"
    }, y), L("chevron")), {
      size: s,
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      mod: ["combobox-chevron", { error: i }, w],
      ref: e,
      children: /* @__PURE__ */ b(
        "path",
        {
          d: "M5.75078 8.8567L1.14019 4.27726C0.953271 4.09034 0.953271 3.91381 1.14019 3.74766L1.73209 3.12461C1.919 2.95846 2.09553 2.95846 2.26168 3.12461L6 6.83178L9.73832 3.12461C9.90447 2.95846 10.081 2.95846 10.2679 3.12461L10.8598 3.74766C11.0467 3.91381 11.0467 4.09034 10.8598 4.27726L6.24922 8.8567C6.08307 9.02284 5.91693 9.02284 5.75078 8.8567Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    })
  );
});
export {
  F as ComboboxChevron
};
